var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dataflow-04",
    clipPath: "url(#clip0_212_20775)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M3 13.5V13.35C3 12.0899 3 11.4598 3.24524 10.9785C3.46095 10.5552 3.80516 10.211 4.22852 9.99524C4.70982 9.75 5.33988 9.75 6.6 9.75H11.4C12.6601 9.75 13.2902 9.75 13.7715 9.99524C14.1948 10.211 14.539 10.5552 14.7548 10.9785C15 11.4598 15 12.0899 15 13.35V13.5M3 13.5C2.17157 13.5 1.5 14.1716 1.5 15C1.5 15.8284 2.17157 16.5 3 16.5C3.82843 16.5 4.5 15.8284 4.5 15C4.5 14.1716 3.82843 13.5 3 13.5ZM15 13.5C14.1716 13.5 13.5 14.1716 13.5 15C13.5 15.8284 14.1716 16.5 15 16.5C15.8284 16.5 16.5 15.8284 16.5 15C16.5 14.1716 15.8284 13.5 15 13.5ZM9 13.5C8.17157 13.5 7.5 14.1716 7.5 15C7.5 15.8284 8.17157 16.5 9 16.5C9.82843 16.5 10.5 15.8284 10.5 15C10.5 14.1716 9.82843 13.5 9 13.5ZM9 13.5V6M4.5 6H13.5C14.1989 6 14.5484 6 14.824 5.88582C15.1916 5.73358 15.4836 5.44157 15.6358 5.07403C15.75 4.79837 15.75 4.44891 15.75 3.75C15.75 3.05109 15.75 2.70163 15.6358 2.42597C15.4836 2.05843 15.1916 1.76642 14.824 1.61418C14.5484 1.5 14.1989 1.5 13.5 1.5H4.5C3.80109 1.5 3.45163 1.5 3.17597 1.61418C2.80843 1.76642 2.51642 2.05843 2.36418 2.42597C2.25 2.70163 2.25 3.05109 2.25 3.75C2.25 4.44891 2.25 4.79837 2.36418 5.07403C2.51642 5.44157 2.80843 5.73358 3.17597 5.88582C3.45163 6 3.80109 6 4.5 6Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_212_20775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataflow);
export default __webpack_public_path__ + "static/media/dataflow.199b55f9e801a973782833f32d0c1aad.svg";
export { ForwardRef as ReactComponent };